<script setup>
import { ref } from "vue";
import { FormModal } from "@Components/Modal";
import { useForm } from "@/form";
import { FormInput, FormLabel } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import { ArrowRightIcon, LinkIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["submit"]);

const { t: __ } = useI18n();

const modal = ref();

const form = useForm({
    url: "",
});

const items = ref([]);

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

const search = async () => {
    if (form.url.length === 0) {
        return;
    }

    items.value = [];
    const response = await form.post("single_mode_sitemap_source_search");
    items.value = response;
};

const selectItem = (item) => {
    emit("submit", item);
    hide();
};

defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" :title="__('Sitemap')" :max-height="items.length > 0 ? '80vh' : undefined">
        <template #body>
            <form @submit.prevent="search">
                <FormLabel for="sitemap-source-url">{{ __("URL du Sitemap") }}</FormLabel>
                <div class="flex justify-center gap-3 mt-2">
                    <div class="flex-1">
                        <FormInput
                            id="sitemap-source-url"
                            v-model="form.url"
                            :errors="form.getErrors('url')"
                            :placeholder="`https://example.com/sitemap.xml`"
                            :z="1" />
                    </div>
                    <div class="mt-[2px] flex-none">
                        <PrimaryButton type="submit" :processing="form.processing" :icon="ArrowRightIcon" :z="1" />
                    </div>
                </div>
            </form>
            <div v-if="items.length > 0" class="mt-3">
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                    {{ __("Sélectionnez l'article source à utiliser") }}
                </div>
                <div class="-mx-2">
                    <div
                        @click="selectItem(item)"
                        v-for="(item, index) in items"
                        :key="index"
                        class="p-2 rounded-md cursor-pointer dark:hover:bg-gray-800 hover:bg-gray-50">
                        <div class="flex">
                            <a @click.stop :href="item.url" target="_blank" class="mt-1 mr-2 text-gray-400 dark:hover:text-gray-200 hover:text-gray-600">
                                <LinkIcon class="w-4 h-4" />
                            </a>
                            <div class="text-sm line-clamp-2 text-gray-900 dark:text-white">{{ item.title }}</div>
                        </div>
                        <div class="mt-0.5 ml-6 text-xs text-gray-400 truncate">{{ item.url }}</div>
                    </div>
                </div>
            </div>
        </template>
    </FormModal>
</template>
